import { useSearchParams } from "react-router-dom";
import { OnboardingType } from "../types";
import { useAppSelector } from "../app/hooks";

const useRemoteParams = () => {
  const { onboardingType: savedTemplate } = useAppSelector(
    (state) => state.activeTemplate,
  );
  const { draftUUID, formValues } = useAppSelector(
    (state) => state.onboardingData,
  );
  const { token: savedToken } = useAppSelector((state) => state.authentication);
  const { cuil: renaperCuit } = useAppSelector((state) => state.renaper);

  const [searchParams] = useSearchParams();
  const remoteOnboardingType = searchParams.get("template") as OnboardingType;
  const remoteDraftUUID = searchParams.get("uuid");
  const remoteToken = searchParams.get("token");
  const continueWithQR = searchParams.get("withQR") === "true";
  const remoteCuit = searchParams.get("cuit");
  const remoteEmail = decodeURIComponent(
    searchParams.get("email") || "",
  ).replace(/ /g, "+");
  const remoteReferrer = decodeURIComponent(
    searchParams.get("ref") || "",
  ).replace(/ /g, "+");

  const token = remoteToken || savedToken || "";
  const onboardingType = savedTemplate || remoteOnboardingType || "";
  const uuid = remoteDraftUUID || draftUUID || "";
  const userCuit = remoteCuit || formValues?.["cuit"] || "";
  const cuit = userCuit || renaperCuit || "";
  const email = remoteEmail || formValues?.["email"] || "";
  const referrer = formValues?.["referrer"] || remoteReferrer;

  const isCrypto = onboardingType === "DIGITAL";

  const remoteUrlParams = new URLSearchParams({
    uuid,
    template: onboardingType,
    ...(isCrypto ? {} : { token, cuit, email }),
    ...(referrer ? { referrer } : {}),
  });

  return {
    remoteUrlParams,
    values: {
      onboardingType,
      uuid,
      token,
      continueWithQR,
      cuit,
      userCuit,
      email,
    },
  };
};

export default useRemoteParams;
